.af-panel,
.af-card {
  background: var(--color-surface);
  color: var(--color-text);
  border: var(--border-width) solid var(--color-border);
  box-shadow: var(--shadow-1);
}

.af-panel {
  border-radius: var(--radius-lg);
  padding: var(--space-5);
}

.af-panel__header {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-4);
  margin-bottom: var(--space-4);
}

.af-panel__title {
  margin: 0;
  font-size: var(--text-xl);
  font-weight: var(--weight-semibold);
  line-height: var(--leading-tight);
  letter-spacing: var(--tracking-tight);
}

.af-panel__description {
  margin: var(--space-1) 0 0;
  color: var(--color-text-muted);
  font-size: var(--text-sm);
}

.af-panel__actions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
}

.af-card {
  border-radius: var(--radius-md);
  padding: var(--space-4);
}

.af-card--elevated {
  box-shadow: var(--shadow-2);
}

.af-card--sunken {
  background: var(--color-sunken);
  box-shadow: none;
}

/* Puesto de control humano: banda lateral ámbar con esquinas casi rectas */
.af-card--control {
  background: var(--color-control-soft);
  border-color: var(--color-control);
  border-left: calc(var(--space-1) + var(--border-width)) solid var(--color-control);
  border-radius: var(--radius-xs);
}
